import { Base64 } from 'js-base64';

const UserService = {
  login: async (requestdata) => {
    const { email, password } = requestdata;
    const { data, headers } = await ovpFetch('/authentication', {
      method: 'POST',
      body: JSON.stringify({ note: 'OVP Frontend' }),
      headers: {
        Authorization: `Basic ${Base64.encode(`${email}:${password}`)}`,
      },
    });

    const returnObject = {
      user: data.user,
      token: data.token,
      assumed: false,
    };

    if (typeof headers['x-streamingbolaget-assumed'] !== 'undefined' && typeof headers['x-streamingbolaget-assumed-id'] !== 'undefined') {
      returnObject.assumed = headers['x-streamingbolaget-assumed-id'];
    }

    return returnObject;
  },
  getUser: async () => {
    const { data, headers } = await ovpFetch('/user');

    const returnObject = {
      user: data,
      assumed: false,
    };

    if (typeof headers['x-streamingbolaget-assumed'] !== 'undefined' && typeof headers['x-streamingbolaget-assumed-id'] !== 'undefined') {
      returnObject.assumed = headers['x-streamingbolaget-assumed-id'];
    }

    return returnObject;
  },
  createUser: async (requestData) => {
    const { data } = await ovpFetch('/account-manager/create', {
      method: 'POST',
      body: JSON.stringify(requestData),
      headers: {
        Authorization: 'token dxLJiHtMd7knwQfkMQxz6DkraY1eDIo1v67qxKmX',
      },
    });
    return data;
  },
  verify: async () => {
    const { headers } = await ovpFetch('/authentication/verify');

    const returnObject = { assumed: false };
    if (typeof headers['x-streamingbolaget-assumed'] !== 'undefined' && typeof headers['x-streamingbolaget-assumed-id'] !== 'undefined') {
      returnObject.assumed = headers['x-streamingbolaget-assumed-id'];
    }

    return returnObject;
  },
  logout: async () => {
    await ovpFetch('/authentication', {
      method: 'DELETE',
      iLikeItRaw: true,
    });
    return true;
  },
  changePassword: async (password) => {
    await ovpFetch('/authentication/changepassword', {
      method: 'POST',
      body: `password=${encodeURIComponent(password)}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return true;
  },
  resetPassword: async (email) => {
    await ovpFetch('/authentication/passwordreset', {
      method: 'POST',
      body: `email=${email}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      iLikeItRaw: true,
    });
    return true;
  },
  resetPasswordCange: async (token, password) => {
    await ovpFetch(`/authentication/passwordreset/${token}`, {
      method: 'POST',
      body: `password=${encodeURIComponent(password)}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      iLikeItRaw: true,
    });
  },
};

// eslint-disable-next-line
export { UserService };
